import { FC } from "react";
import { BreakableName } from "../../../helper/general/methods";

interface ReportIconProps {
  reportName: string;
  isSelected: boolean;
  onClick: () => void;
}

const ReportIcon: FC<ReportIconProps> = ({
  reportName,
  isSelected,
  onClick,
}) => {
  return (
    <div
      className={isSelected ? "selectedItem" : "unSelectedItem"}
      onClick={onClick}
    >
      <img
        className="icon-big"
        src="assets/icons/report.png"
        draggable="false"
        alt={reportName}
      />
      <span title={reportName}>{BreakableName(reportName)}</span>
    </div>
  );
};

export default ReportIcon;
